export default __webpack_public_path__ + "static/building-blocks-7d206f7d1322e14297b082126547f420.svg";